import React, { useState } from 'react'
import { AiOutlineHome } from 'react-icons/ai';
import { FaRegCalendar } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {ReactComponent as ArrowLeft} from "../../images/arrow_left.svg"
import MpaasAdminPanelApi from '../../utils/MpaasAdminPanelApi';
import './DownloadProctorFeedback.css'
import { FEEDBACK_CONSTANTS } from './feedback.constant';

export const DownloadProctorFeedback = () => {
    const [formData, setFormData] = useState({
        clientId: '',
        startDate: '',
        endDate: ''
    });
    const [response, setResponse] = useState({ message: '', isError: false });

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleDownloadFeedback = async () => {
        const { clientId, startDate, endDate } = formData;

        if (!clientId || !startDate || !endDate) {
            setResponse({ isError: true, message: 'Please provide Client Id, Start Date and End Date.' });
            return;
        }

        try {
            const response: any = await MpaasAdminPanelApi.downloadProctorFeedback({ clientId, startDate, endDate });
            const { fileName = FEEDBACK_CONSTANTS.DEFAULT_FILE_NAME, mimeType = FEEDBACK_CONSTANTS.DEFAULT_MIME_TYPE, fileData } = response;

            if (!fileData) {
                throw new Error('Invalid response: missing file data.');
            }

            const byteCharacters = atob(fileData);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], { type: mimeType });
            const downloadUrl = URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            downloadLink.setAttribute('download', fileName);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadUrl);

            setResponse({ isError: false, message: 'Proctor feedback file downloaded successfully.' });
        } catch (error: any) {
            setResponse({ isError: true, message: error?.message || 'Failed to download proctor feedback file.' });
        }
    };

    return (
        <div className="ml-3 mt-3">
            <div className='breadcrumb-section'>
                <AiOutlineHome />
                <span className="small"> &gt; <Link to="/settings" className="text-muted">Settings</Link> </span>
                <span className="small"> &gt; <span className="text-muted">Proctor Feedback</span> </span>
                <span className="small"> &gt; <span className="text-muted">Download Proctor Feedback</span> </span>
            </div>

            <div className='mt-3 d-flex flex-row align-items-start'>
                <Link to="/settings"><ArrowLeft /></Link>
                <div className='d-flex flex-column nav-padding'>
                    <h5>Download Proctor Feedback File</h5>
                    <p className="text-muted">You can download proctor feedback file here</p>
                </div>
            </div>
            <p className="font-weight-bold mt-3 text-quill-lighter h6 mb-4">Download Proctor Feedback File</p>
            <div className="mr-3">
                Client Id
                <input
                    name="clientId"
                    value={formData.clientId}
                    onChange={handleInputChange}
                    placeholder='Enter Client Id'
                    className='form-control client-id-field py-1 rounded-2'
                />
            </div>
            <div className="d-flex align-items-center mt-3 gap-3 w-50">
                <div className="mr-3">
                    Start Date
                    <div className="date-field flex-grow-1 d-flex align-items-center position-relative">
                        <FaRegCalendar className="date-icon position-absolute ml-2" />
                        <input
                            type="date"
                            id="startDate"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleInputChange}
                            placeholder="Enter start date"
                            className="form-control date-input-field px-4 py-2 rounded-2"
                        />
                    </div>
                </div>
                <div className="mr-3">
                    End Date
                    <div className="date-field flex-grow-1 d-flex align-items-center position-relative">
                        <FaRegCalendar className="date-icon position-absolute ml-2" />
                        <input
                            type="date"
                            id="endDate"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleInputChange}
                            placeholder="Enter end date"
                            className="form-control date-input-field px-4 py-2 rounded-2"
                        />
                    </div>
                </div>
                <button className="btn btn-primary text-white px-3 py-2 mt-3" onClick={handleDownloadFeedback}>Download Feedback</button>
            </div>
            <p className={`response-message ${response.isError ? 'text-danger' : 'text-success'}`}>{response.message}</p>
        </div>
    );
}